import {
  DesktopDatePicker,
  DesktopDatePickerProps,
  LocalizationProvider
} from "@mui/x-date-pickers";
import React, { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import { Csizes } from "@/shared/theme/theme";
import { IEventChangeCallBack } from "@rf-model/event-change.model";

type omit = "renderInput";
type MxTextDateFieldValue = dayjs.Dayjs | null | string;
export interface MxTextDateFieldProps
  extends Omit<DesktopDatePickerProps<any, any>, omit> {
  id?: string;
  name: string;
  error?: boolean;
  ref: any;
  onBlur?: any;
  onValueChange?: IEventChangeCallBack<MxTextDateFieldValue>;
  backgroundColor?: string;
}
const MxTextDateField = React.forwardRef<any, MxTextDateFieldProps>((props, ref) => {
  const { value, onChange, error, ...rest } = props;
  const [data, useData] = useState<any>(null);
  const id = window.crypto.randomUUID();

  const shrink = Boolean(props.value);

  const handleChange = (newValue: Dayjs | null) => {
    const state: any = {
      target: {
        value: dayjs(newValue).format("YYYY-MM-DD"),
        name: props.name ?? ""
      }
    };
    useData(newValue);
    onChange(state);
    props?.onValueChange && props?.onValueChange(state);
    props.onBlur && props.onBlur(state);
  };

  useEffect(() => {
    if (props.value) {
      useData(dayjs(props.value));
    } else {
      useData(null);
    }
  }, [props.value]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        {...rest}
        OpenPickerButtonProps={{
          id: id
        }}
        value={data}
        data-testid={`${props.id || props.name}-text-date-field`}
        backgroundColor={props.backgroundColor}
        onChange={v => handleChange(v as Dayjs | null)}
        renderInput={params => (
          <TextField
            {...params}
            fullWidth
            data-testid={`${props.id || props.name}-text-date-field-input`}
            onBlur={props.onBlur}
            onClick={() => document.getElementById(id)?.click()}
            error={error}
            InputLabelProps={{
              shrink
            }}
            ref={ref}
          />
        )}
        PopperProps={{ sx: { zIndex: 10000 } }}
        inputFormat="DD/MM/YYYY"
      />
    </LocalizationProvider>
  );
});

export default MxTextDateField;

const DatePicker = styled(DesktopDatePicker)<{ backgroundColor?: string }>(
  ({ theme, backgroundColor = "transparent" }) => ({
    "& .MuiOutlinedInput-root": {
      borderRadius: 50,
      display: "flex",
      height: Csizes.input,
      minHeight: Csizes.input,
      backgroundColor: backgroundColor
    },
    "& .MuiFormLabel-root": {
      fontSize: 12,
      color: theme.palette.primary.main,
      '&[data-shrink="false"]': {
        transform: "translate(0.7rem, 0.49rem) scale(0.96)"
        // marginTop: 7.7
      },
      '&[data-shrink="true"]': {}
    },
    "& ::placeholder": {
      fontSize: 12,
      color: "transparent"
    },
    "& .MuiInputBase-input": {
      fontSize: 12
    },
    "& .MuiInputBase-input:disabled": {
      color: "var(--m-color-blue-03)",
      cursor: "not-allowed"
    },
    input: {
      minHeight: Csizes.input,
      height: Csizes.input
    }
  })
);
